import { CompetitionWithId } from "../interfaces/ICompetitions";
import { createContext, ReactNode, useContext } from "react";
import { useCompetitions } from "../hooks/useCompetitions";

interface CompetitionsContextType {
  competitions: CompetitionWithId[];
  loading: boolean;
  error: string | null;
  refreshCompetitions: () => Promise<void>;
}

const CompetitionsContext = createContext<CompetitionsContextType | undefined>(undefined);

export const useCompetitionsContext = (): CompetitionsContextType => {
  const context = useContext(CompetitionsContext);
  if (context === undefined) {
    throw new Error("useCompetitionsContext must be used within a CompetitionsContextProvider");
  }
  return context;
};

interface CompetitionsContextProviderProps {
  children: ReactNode;
}

export const CompetitionsContextProvider = ({ children }: CompetitionsContextProviderProps) => {
  const { competitions, loading, error, refreshData } = useCompetitions();

  return (
    <CompetitionsContext.Provider
      value={{
        competitions,
        loading,
        error,
        refreshCompetitions: refreshData,
      }}
    >
      {children}
    </CompetitionsContext.Provider>
  );
};
